import type { feedback as enFeedback } from "../en/feedback";

export const feedback: typeof enFeedback = {
  pageHeading: "Invia un feedback",
  intro: {
    heading: "Dicci cosa funziona e cosa no",
    body:
      "Leggiamo ogni risposta. Il modo più veloce per influenzare cosa sviluppiamo dopo è lasciare qui una nota chiara — analizziamo e rispondiamo a ogni segnalazione entro 2 giorni lavorativi.",
    shopLabel: "Negozio:",
    tierLabel: "Piano:",
  },
  success: {
    banner: "Grazie — l'abbiamo ricevuto. Ti risponderemo entro 2 giorni lavorativi.",
    trackedPublicly: "Tracciato pubblicamente:",
  },
  form: {
    heading: "Il tuo feedback",
    subjectLabel: "Oggetto",
    subjectPlaceholder: "es. Il caricamento del PDF dell'ordine d'acquisto fallisce silenziosamente per PO di 2 pagine",
    roleLabel: "Qual è il tuo rapporto con questo negozio?",
    roleOptions: {
      merchant: "Gestisco questo negozio",
      reviewer: "Recensore dell'App Store",
      buyer: "Acquirente B2B di questo negozio",
      other: "Altro",
    },
    contactEmailLabel: "Email per la risposta (opzionale)",
    contactEmailPlaceholder: "noi@tuaemail.com — lascia vuoto per restare anonimo",
    bodyLabel: "Raccontaci cosa è successo",
    bodyPlaceholder:
      "Passaggi per riprodurre il problema + cosa ti aspettavi + cosa è successo. Screenshot benvenuti — incolla i link.",
    sendButton: "Invia feedback",
  },
  errors: {
    subjectRequired: "L'oggetto è obbligatorio (≤200 caratteri).",
    messageRequired: "Il messaggio è obbligatorio (≤8000 caratteri).",
  },
};
